import Controller from '@ember/controller';

import { LottiePlayer } from '@repo/design-system-kit';

import { AppStoreBadge } from 'register-partners-js/react/components/app-store-badge';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { PlayStoreBadge } from 'register-partners-js/react/components/play-store-badge';

import styles from './styles.module.css';

export default class NextStepsControllerController extends Controller {
  lottiePlayer = LottiePlayer;
  playStoreBadge = PlayStoreBadge;
  appStoreBadge = AppStoreBadge;
  mainLayout = MainLayout;
  styles = styles;
}
